const o="object"==typeof globalThis&&"crypto"in globalThis?globalThis.crypto:void 0;export{o as crypto};
//# sourceMappingURL=crypto.mjs.map
